// --------------------------------------------------------------------------
// MODULE #56 – SORT BY
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var currentValue = context.find('[data-binding="current-value"]');
    var list = context.find('[data-binding="list"]');

    function init() {
        currentValue.text('Please select...');

        currentValue.on({
            click: function click(e) {
                e.preventDefault();
                $(this).toggleClass('open');
                list.slideToggle();
            },
            keyup: function keyup(e) {
                console.log(e);
                if (e.keyCode === 13) {
                    $(this).toggleClass('open');
                    list.slideToggle();
                }
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activities-sort-options.js
// module id = 206
// module chunks = 0